module.exports = __webpack_public_path__ + "static/img/10.6f4ece5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/5/zh/10.png
// module id = UQ06
// module chunks = 0